import type { CandleBucketSize, Timeframe } from "./enum"

export const timeframeToSeconds = (timeframe: Timeframe): number => {
  switch (timeframe) {
    case "ONE_MINUTE":
      return 60
    case "FIVE_MINUTE":
      return 300
    case "FIFTEEN_MINUTE":
      return 900
    case "ONE_DAY":
      return 86_400
    case "ONE_HOUR":
      return 3600
    case "SEVEN_DAYS":
      return 604_800
    case "THIRTY_DAYS":
      return 2_592_000
    case "ONE_YEAR":
      return 31_536_000
    case "ALL_TIME":
      return Number.POSITIVE_INFINITY
  }
}

export const candleBucketSizeToSeconds = (
  bucketSize: CandleBucketSize,
): number => {
  switch (bucketSize) {
    case "ONE_MINUTE":
      return 60
    case "FIVE_MINUTES":
      return 300
    case "FIFTEEN_MINUTES":
      return 900
    case "ONE_HOUR":
      return 3600
    case "FOUR_HOURS":
      return 14_400
    case "ONE_DAY":
      return 86_400
  }
}
